import React from "react";
import "./style.scss";
import { formatMessage } from "devextreme/localization";

export default function Education({ employee = {} }) {
  return (
    <div>
      <div className="form-readonly ma-2">
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">{formatMessage("EducationRank")}</div>
            <div className="form-value">
              <span>{employee?.EducationRank?.EducationRankName}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">{formatMessage("GraduateSchool")}</div>
            <div className="form-value">
              <span>{employee.GraduateSchool}</span>
            </div>
          </div>
        </div>
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">{formatMessage("Certificate")}</div>
            <div className="form-value">
              <span>{employee?.Certificate?.CertificateName}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">{formatMessage("Major")}</div>
            <div className="form-value">
              <span>{employee?.Major?.MajorName}</span>
            </div>
          </div>
        </div>

        <div className="form-col">
          <div className="form-group">
            <div className="form-label">{formatMessage("ForeignLevel")}</div>
            <div className="form-value">
              <span>{employee?.ForeignLevel?.ForeignLevelName}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
